<template>
  <div>
    <!-- 之前的代码 -->
    <ul class="flex scroll-x themeList">
      <li v-for="(item, index) in treeList" :key="index" class="tree-item flex"
        :class="{ active: item.id == id }" @click="handleClick(item)">
        <div class="icon">
          <i class="iconfont icon-form"></i>
        </div>
        <div class="text">
          {{ item.classifyName }}
        </div>
      </li>
    </ul>
    <!-- 猜你想问 -->
    <div class="guessAsk">
      <div class="changeGuess">
        <!-- <p>{{ name }}</p> -->
        <p>常见情景</p>
        <p @click="changeGuess"><i class="el-icon-refresh"></i>换一换</p>
      </div>
      <ul class="guessList" v-if="guessList.length > 0">
        <li v-for="(item, index) in list" :key="index" @click="handleSendMessage(item)">
          <div class="text">
            {{ item.flowName }}
          </div>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <div class="getfail" v-else>
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      treeList: {
        type: Array
      },
      guessList: {
        type: Array
      },
      classifyId: {
        type: [String,Number]
      },
      classifyName: {
        type: String
      },
      activeName: {
        type: [String,Number]
      },
      isRandom: {
        type: Boolean
      },
      quesNum: {
        type: Number
      }
    },
    data() {
      return {
        id: "",
        name: "",
        tabId: '',
        list: [],
        num: 0,
        questionNum: null
      };
    },
    components: {},
    watch: {
      classifyId: {
        handler(val) {
          this.id = val;
          this.name = this.classifyName;
          // this.getGuessList(val,this.tabId);
          console.log('分类变化')
        },
        immediate: true
      },
      activeName: {
        handler(val) {
          this.tabId = val;
          this.id = this.classifyId;
          console.log('最新的tab',this.classifyId)
          // this.getGuessList(this.id,this.tabId);
        },
        immediate: true
      },
      guessList: {
        handler(val) {
          this.list = val;
        },
        immediate: true
      },
      quesNum: {
        handler(val) {
          this.questionNum = val;
        },
        immediate: true
      }
    },
    methods: {
      changeGuess() {
        this.getGuessList(this.id,this.tabId)
      },
      // 获取当前主题下的推荐问题
      getGuessList(id,tabId) {
        if(id) {
          // 以前的接口
          this.$axios.get("/conversation/list/flow", {
            classifyId: id,
            questionCustomer: tabId
          }).then((res) => {
            this.questionNum = res.content.length;
            if(!this.isRandom) {
              this.list = res.content.slice(0, 3);
            }else{
              
              if((this.num+1) *3 >= this.questionNum) {
                this.num = 0
              }else{
                this.num ++;
              }
              this.list = res.content.slice(this.num*3, (this.num+1)*3);
            }
          }).catch((err) => {
          });
          
        }
      },
      handleSendMessage(e) {
        console.log('点击常见情景------', e)
        
        this.$store.commit('SET_BUBBLE', false);
        this.$emit("handleSendMessage", {
          ...e,
          questionCustomer: this.tabId
        });
      },
      handleClick(e) {
        this.id = e.id;
        this.name = e.classifyName;
        this.getGuessList(e.id,this.tabId)
        this.$store.commit('SET_ARR', [])
        
      },
     
    },
    created() {
    },
    mounted() {
      this.id = this.classifyId;
      this.name = this.classifyName;
    },
  };
</script>
<style lang="scss" scoped>
.getfail {
  text-align: center;
  color: #666;
  margin-top: 20px;
}
// tab
::v-deep .el-tabs--border-card {
  border: none;
  box-shadow: none;
  border-radius: 4px;
  margin: 0 10px;
  .el-tabs__header{
    border-bottom: 1px solid #eeecec;
    .el-tabs__item{
      color: #303133;
    }
    .el-tabs__item.is-active{
      border-top-left-radius: 4px;
      color: #3b62f1;
      border-right-color: #eeecec;
      border-left-color: #eeecec;
    }
    .el-tabs__item:not(.is-disabled):hover{
      color: #3b62f1;
    }
  }
  .el-tabs__nav-wrap{
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

  }
  
}
  .session-line {
    display: flex;
    align-items: center;

    .text {
      font-size: 14px;
      margin: 0 10px;
      color: #999;
    }

    .line {
      border-top: 1px dashed #999;
      flex: 1;
    }
  }

  // 之前的代码
  .example {
    .ques-list {
      background-color: #fff;
      padding: 6px;
      border-radius: 6px;

      .ques-item {
        line-height: 30px;
        font-size: 14px;
        color: #3d7eff;
      }
    }

    ul {
      margin-bottom: 10px;
      // margin: 0 10px 10px;
      list-style-type: none;
    }

    .themeList {
      display: flex;
      justify-content: space-between;
    }

    .tree-item {
      font-size: 12px;
      // background-color: #fff;
      background-color: #f5f6f8;
      padding: 6px;
      border-radius: 6px;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 15%;

      .icon {
        margin-bottom: 6px;
        height: 24px;
        width: 24px;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #3d7eff19 !important;

        i {
          font-size: 14px;
          color: #3d7eff;
        }
      }

      .text {
        white-space: nowrap;
        color: black;
      }
    }

    .active {
      background-color: #3b62f1;
      color: #fff;

      .text {
        color: #fff;
      }

      .icon {
        background-color: #fff !important;
      }
    }
  }

  .guessAsk {
    background: #f5f6f8;
    border-radius: 4px;
    box-shadow: 0 0 5px #f5f6f8;
    padding: 15px;
    box-sizing: border-box;
    // margin: 0 10px;
    font-size: 14px;

    .changeGuess {
      display: flex;
      justify-content: space-between;

      p {
        &:nth-of-type(1) {
          font-weight: bold;
        }

        &:nth-of-type(2) {
          color: #3b62f1;
        }
      }
    }

    .guessList {
      margin: 10px 0 0;
    }

    .guessList li {
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eeecec;

      .text {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 80%;
      }

      &:last-child {
        border: none;
      }
    }
  }
</style>